import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import { getErrorAsList } from "../utils";

import { DEFAULT_LIST_OPTION } from "../../components/Collaborator/CollaboratorList/CollaboratorList";

const initialState = {
  loading: false,
  error: undefined,
  collaboratorDetail: undefined,
  collaboratorList: [],
  collaboratorListOption: DEFAULT_LIST_OPTION,
};

export const clearErrorCollaborator = createAction("collaborators/clearErrorCollaborator");

export const setListOptionCollaborator = createAction("collaborators/setListOptionCollaborator");

export const getAllCollaborators = createAsyncThunk("collaborators/getAllCollaborators", async (args, thunkAPI) => {
  try {
    const filter = args.filter ? "?filter=" + args.filter : "";
    const { data } = await api.get(`/api/collaborators/${filter}`);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const getCollaborator = createAsyncThunk("collaborators/getCollaborator", async (args, thunkAPI) => {
  try {
    const { data } = await api.get(`/api/collaborators/${args.id}/`);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const insertCollaborator = createAsyncThunk("collaborators/insertCollaborator", async (args, thunkAPI) => {
  try {
    const body = {
      name: args.name,
      email: args.email,
      team: args.teamId,
      seniority: args.seniorityId,
      project: null,
      is_admin: args.isAdmin,
    };
    const { data } = await api.post("/api/users/register/", body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const updateCollaborator = createAsyncThunk("collaborators/updateCollaborator", async (args, thunkAPI) => {
  try {
    const body = {
      team: args.teamId,
      seniority: args.seniorityId,
      project: args.projectId,
    };
    const { data } = await api.put(`/api/collaborators/${args.id}/`, body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const arquiveCollaborator = createAsyncThunk("collaborators/arquiveCollaborator", async (args, thunkAPI) => {
  try {
    const body = {
      is_archived: args.is_archived,
    };
    const { data } = await api.patch(`/api/users/${args.id}/`, body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const promoteCollaborator = createAsyncThunk("collaborators/promoteCollaborator", async (args, thunkAPI) => {
  try {
    const body = {
      is_admin: args.is_admin,
    };
    const { data } = await api.patch(`/api/users/${args.id}/promote/`, body);
    return data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const collaboratorSlice = createSlice({
  name: "collaborator",
  initialState,
  extraReducers: {
    // Clear error (if any)
    [clearErrorCollaborator]: (state) => {
      state.error = undefined;
    },

    // Set list option
    [setListOptionCollaborator]: (state, action) => {
      state.collaboratorListOption = action.payload;
    },

    // Get all
    [getAllCollaborators.pending]: (state) => {
      state.loading = true;
    },
    [getAllCollaborators.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.collaboratorList = action.payload;
    },
    [getAllCollaborators.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Get
    [getCollaborator.pending]: (state) => {
      state.loading = true;
    },
    [getCollaborator.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.collaboratorDetail = action.payload;
    },
    [getCollaborator.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Insert
    [insertCollaborator.pending]: (state) => {
      state.loading = true;
    },
    [insertCollaborator.fulfilled]: (state) => {
      state.loading = false;
      state.error = undefined;
    },
    [insertCollaborator.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update
    [updateCollaborator.pending]: (state) => {
      state.loading = true;
    },
    [updateCollaborator.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.collaboratorDetail = action.payload;
    },
    [updateCollaborator.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Arquive
    [arquiveCollaborator.pending]: (state) => {
      state.loading = true;
    },
    [arquiveCollaborator.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.collaboratorDetail = { ...state.collaboratorDetail, user: action.payload };
    },
    [arquiveCollaborator.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Promote
    [promoteCollaborator.pending]: (state) => {
      state.loading = true;
    },
    [promoteCollaborator.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.collaboratorDetail = { ...state.collaboratorDetail, user: action.payload };
    },
    [promoteCollaborator.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default collaboratorSlice.reducer;
